if (window.location.href.includes("ai-skin-analysis")) {
	const pageTitle = document.querySelector('.page-title__title');
	if (pageTitle) {
		pageTitle.remove();
	}
}

window.addEventListener('message', function(e) {
	    var $iframe = document.getElementById('renude-analysis');
	    var eventName = e.data[0];
	    var data = e.data[1];

	    function createCartWithCustomAttributes(
	      sessionId,
	      businessId,
	      productId,
	      mentionedProductId = []
	    ) {
	      // First, check if the cart already has items
	      fetch(window.Shopify.routes.root + "cart.js")
	        .then((response) => response.json())
	        .then((cart) => {
	          if (cart.items.length === 0) {
	            // The cart is empty, create a cart with a zero-quantity product
	            const cartData = {
	              items: [
	                {
	                  quantity: 0, // Zero quantity means no visible product
	                  id: productId, // A valid variant ID for a placeholder product
	                  properties: {
	                    session_id: sessionId,
	                    business_id: businessId,
	                    mentionedProductId: mentionedProductId,
	                  },
	                },
	              ],
	            };

	            fetch(window.Shopify.routes.root + "cart/add.js", {
	              method: "POST",
	              headers: {
	                "Content-Type": "application/json",
	              },
	              body: JSON.stringify(cartData),
	            })
	              .then((response) => response.json())
	              .then(() => {
	                // Update the cart attributes once the cart is created
	                updateCartAttributes(sessionId, businessId, mentionedProductId);
	              })
	              .catch((error) => {
	                console.error("Error creating cart:", error);
	              });
	          } else {
	            // The cart already has products, so just update the attributes
	            updateCartAttributes(sessionId, businessId, mentionedProductId);
	          }
	        })
	        .catch((error) => {
	          console.error("Error checking cart:", error);
	        });
	    }

	    // Function to update cart attributes (session_id, business_id)
	    function updateCartAttributes(sessionId, businessId, mentionedProductId) {
	      const updates = {
	        attributes: {
	          session_id: sessionId,
	          business_id: businessId,
	          mentionedProductId: mentionedProductId,
	        },
	      };

	      fetch(window.Shopify.routes.root + "cart/update.js", {
	        method: "POST",
	        headers: {
	          "Content-Type": "application/json",
	        },
	        body: JSON.stringify(updates),
	      })
	        .then((response) => response.json())
	        .then((data) => {
	          console.log("Cart attributes updated:", data);
	        })
	        .catch((error) => {
	          console.error("Error updating cart attributes:", error);
	        });
	    }

	    switch(eventName) {
	        case 'setHeight':
	            $iframe.height = data;
	            break;
	        case 'setTopByWindow':
	          window.scrollTo({ top: data, behavior: 'smooth' });
	          break;
	        case 'setTopByIframe':
	           $iframe.scrollIntoView({behavior: 'smooth', block: 'start'});
	          break;
			case 'showModal':
				var iframeRect = $iframe.getBoundingClientRect();
				var iframeMidpoint = iframeRect.top + iframeRect.height / 2;
				window.scrollTo({ top: 750, behavior: 'smooth' });
	          break;
	      case 'renude-setup-track':
	          const payloadData = JSON.parse(data)
	            createCartWithCustomAttributes(
	              payloadData.session_id,
	              payloadData.BID,
	              payloadData.external_id,
	              payloadData.mentionedProductId
	            );
	        break;
	    }
	}, false);